/**
 * Script for All Pages
 *
 * @author Space-Time Inc.
 * @version 2024-02-13
 */

/**
 * Minimum Viewport (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

(() => {
    const MIN_WIDTH = 360;

    const vp = document.querySelector('meta[name="viewport"]');
    function fn() {
        const v = window.outerWidth > MIN_WIDTH ? "width=device-width,initial-scale=1" : `width=${MIN_WIDTH}`;
        if (vp.getAttribute("content") !== v) {
            vp.setAttribute("content", v);
        }
    }
    addEventListener("resize", throttle(fn), false);
    fn();

    /**
     * Throttling Function
     *
     * @author Space-Time Inc.
     * @version 2022-10-13
     */
    
    function throttle(fn) {
        let isRunning;
        return (...args) => {
            if (isRunning) return;
            isRunning = true;
            requestAnimationFrame(() => {
                isRunning = false;
                fn(...args);
            });
        };
    }
    
})();

/**
 * Scroll To Top
 *
 * @author Space-Time Inc.
 * @version 2024-02-09
 */

(() => {
    function init() {
        const btn = document.getElementById("scroll-to-top");
        if (btn === null) return;
        const ph = btn.parentElement;

        const offset = parseInt(btn.dataset["offset"] ?? "0");
        const align = btn.dataset["align"] ?? "bottom";

        let fact = 0;
        switch (align) {
            case "top":
                fact = 0;
                break;
            case "middle":
                fact = 0.5;
                break;
            case "bottom":
                fact = 1;
                break;
        }

        onScroll(scrollHandler);
        onResize(scrollHandler);
        if ("ontouchstart" in window) window.addEventListener("touchmove", scrollHandler);
        setTimeout(scrollHandler, 100);

        btn.addEventListener("click", () => {
            window.scroll({ top: 0, behavior: "smooth" });
        });

        function scrollHandler() {
            const btnR = btn.getBoundingClientRect();
            const btnH = (btnR.bottom - btnR.top) * fact;

            const viewBottomY = window.innerHeight - offset - btnH;
            const footerTopY = ph.getBoundingClientRect().top;

            if (viewBottomY > footerTopY) {
                btn.style.transform = "translateY(-" + (viewBottomY - footerTopY + offset) + "px)";
                btn.classList.remove("fixed");
            } else {
                btn.style.transform = `translateY(-${offset}px)`;
                btn.classList.add("fixed");
            }

            if (window.scrollY > window.innerHeight / 3) {
                btn.classList.remove("hidden");
            } else {
                btn.classList.add("hidden");
            }
        }
    }

    // -------------------------------------------------------------------------

    /**
     * Throttling Function
     *
     * @author Space-Time Inc.
     * @version 2022-10-13
     */
    
    function throttle(fn) {
        let isRunning;
        return (...args) => {
            if (isRunning) return;
            isRunning = true;
            requestAnimationFrame(() => {
                isRunning = false;
                fn(...args);
            });
        };
    }
    

    const resizeListeners = [];
    const scrollListeners = [];

    function onResize(fn, doFirst = false) {
        if (doFirst) fn();
        resizeListeners.push(throttle(fn));
    }

    function onScroll(fn, doFirst = false) {
        if (doFirst) fn();
        scrollListeners.push(throttle(fn));
    }

    document.addEventListener("DOMContentLoaded", () => {
        window.addEventListener(
            "resize",
            () => {
                for (const l of resizeListeners) l();
            },
            { passive: true }
        );
        window.addEventListener(
            "scroll",
            () => {
                for (const l of scrollListeners) l();
            },
            { passive: true }
        );
    });

    init();
})();

/**
 * Search Popup (JS)
 *
 * @author Space-Time Inc.
 * @version 2024-02-13
 */
document.addEventListener("DOMContentLoaded", () => {
    const btn = document.querySelector("#btn-search-popup");
    if (!btn) return;

    const popup = document.querySelector("#search-popup");
    if (!popup) return;

    // ポップアップの開閉
    btn.addEventListener("click", () => {
        btn.classList.toggle("open");
        popup.classList.toggle("open");
    });

    // 検索フォームが送信された時にポップアップを閉じる
    const form = document.querySelector('.search-form');
    if (form) {
        form.addEventListener('submit', () => {
            // ポップアップを閉じる
            btn.classList.remove("open");
            popup.classList.remove("open");
        });
    }
});
/**
 * Toggle Button
 *
 * @author Space-Time Inc.
 * @version 2023-02-21
 */

document.addEventListener("DOMContentLoaded", () => {
    const btns = document.querySelectorAll('.user-content *[class^="button"]');

    for (let i = 0; i < btns.length; i += 1) {
        if (isToggleButton(btns[i])) setEventListener(btns[i]);
    }

    function isToggleButton(btn) {
        if (!btn.href || btn.href[btn.href.length - 1] !== "#") return false;
        const p = btn.parentElement;
        const f = p.nextElementSibling;
        return f.classList.contains("frame") || f.classList.contains("frame-alt");
    }

    function setEventListener(btn) {
        btn.classList.add("toggle");
        initFrame(btn);
        btn.addEventListener("click", (e) => {
            if (btn.classList.contains("active")) {
                btn.classList.remove("active");
                setFrameVisible(btn, false);
            } else {
                btn.classList.add("active");
                setFrameVisible(btn, true);
            }
            e.preventDefault();
        });
    }

    function initFrame(btn) {
        const p = btn.parentElement;
        const f = p.nextElementSibling;
        f.style.display = "none";
        f.classList.add("hidden");
        setTimeout(() => {
            f.style.display = "";
        }, 10);
    }

    function setFrameVisible(btn, visible) {
        const p = btn.parentElement;
        const f = p.nextElementSibling;
        if (visible) {
            f.classList.remove("hidden");
        } else {
            f.classList.add("hidden");
        }
    }
});

window.addEventListener("DOMContentLoaded", () => {
    const toggleMenuButton = document.getElementById("toggle-menu");
    const toggleCloseButton = document.getElementById("toggle-close");
    const navList = document.querySelector(".nav-content");
    const firstLevelButtons = document.querySelectorAll(".gnav.nav-list .group button");
    const panels = document.querySelectorAll(".menu-global-panel");
    const page = document.querySelector("#page");
    const headerMain = document.querySelector(".site-header .main");
    let disableMouseEnter = false;

    if (!toggleMenuButton) return;

    // ユーティリティ関数
    const disableMouseEnterTemporarily = () => {
        disableMouseEnter = true;
        setTimeout(() => (disableMouseEnter = false), 150);
    };

    const showMenu = () => {
        navList.classList.add("open");
        toggleCloseButton.style.display = "block";
        toggleMenuButton.style.display = "none";
        // if (window.innerWidth < 600) {
        //     // 600px未満の時のみ実行する処理
        //     document.body.style.overflow = "hidden";
        // }

        updatePagePadding();
        updateToggleMenuVisibility();
        setActiveMenu();
        // console.log(panels);
    };

    const hideMenu = () => {
        navList.classList.remove("open");
        panels.forEach((panel) => panel.classList.remove("open"));
        toggleCloseButton.style.display = "none";
        toggleMenuButton.style.display = "block";

        // この処理をスマホだけに変更したい
        // if (window.innerWidth < 600) {
        //     // 600px未満の時のみ実行する処理
        //         document.body.style.overflow = "auto";
        // }
        headerMain.classList.remove("small");
        updatePagePadding();
        disableMouseEnterTemporarily();

        //         setTimeout(() => {
        //         //const panels = document.querySelectorAll(".menu-global-panel");
        //         const parentMenu = document.querySelector(".menu-global-panel .menu_second, .menu-global-panel .menu_third");
        //         const currentItem = parentMenu?.querySelector(".current");
        //         console.log(parentMenu);
        //
        //         if (currentItem && parentMenu) {
        //             // current が見えるようにスクロール
        //             currentItem.scrollIntoView({
        //                 block: "nearest",
        //                 behavior: "smooth", // スムーズスクロール
        //             });
        //         }
        // }, 100);
    };

    const openPanel = (panelId) => {
        const targetPanel = document.getElementById(panelId);
        if (targetPanel) {
            panels.forEach((panel) => panel.classList.remove("open"));
            targetPanel.classList.add("open");
            if (!navList.classList.contains("open")) {
                showMenu();
            }
            // updatePagePadding();
        }
    };

    // 初期化
    const initializeMenuState = () => {
        headerMain.classList.remove("small");
        const isSpecialPage = document.body.classList.contains("page-template-template-curation") || document.body.classList.contains("home");

        if (!isSpecialPage && window.innerWidth >= 1056) {
            setActiveMenu();
            document.body.classList.add("disable-anim");
            setTimeout(() => document.body.classList.remove("disable-anim"), 500);
        } else {
            navList.classList.remove("open");
            toggleMenuButton.style.display = "block";
        }
        updateToggleMenuVisibility();
    };

    // 現在のページに基づいてメニューを展開

    const setActiveMenu = () => {
        toggleCloseButton.style.display = "block";

        // すべての "opened" クラスを削除
        document.querySelectorAll(".group.opened").forEach((group) => {
            group.classList.remove("opened");
        });

        // 現在のページに対応するメニュー項目を開く
        openMenuHierarchy();

        if (!navList.classList.contains("open")) {
            navList.classList.add("open");
        }

        updatePagePadding();
        //         setTimeout(() => {
        //         //const panels = document.querySelectorAll(".menu-global-panel");
        //             const parentMenu = document.querySelector(".menu-global-panel .menu_second, .menu-global-panel .menu_third");
        //             const currentItem = parentMenu?.querySelector(".current");
        //         //  console.log(parentMenu);
        //
        //             if (currentItem && parentMenu) {
        //                 // current が見えるようにスクロール
        //                 currentItem.scrollIntoView({
        //                     block: "nearest",
        //                     behavior: "smooth", // スムーズスクロール
        //                 });
        //             }
        //         }, 100);
    };

    const openMenuHierarchy = () => {
        const currentPath = window.location.pathname;
        let foundMatch = false;

        // 1. 第3階層 or 第2階層の親候補を取得
        const allParentItems = document.querySelectorAll(
            ".menu-global-panel .menu_third li.page-parent, .menu-global-panel .menu_third li.menu-parent, .menu-global-panel .menu_third li.page-ancestor, .menu-global-panel .menu_second li.page-parent, .menu-global-panel .menu_second li.page-ancestor"
        );

        allParentItems.forEach((parentItem) => {
            const parentLink = parentItem.querySelector("a");
            if (!parentLink) return;

            const parentPath = parentLink.pathname;

            if (
                parentLink.hostname === location.hostname && // 同一ドメインのみ対象
                currentPath.startsWith(parentPath) &&
                currentPath !== parentPath
            ) {
                foundMatch = true;

                const panel = parentItem.closest(".menu-global-panel");
                if (panel) {
                    panel.classList.add("open");

                    // スクロール位置の調整
                    const currentItem = panel.querySelector(".current");
                    if (currentItem) {
                        currentItem.scrollIntoView({
                            behavior: "smooth", // スムーズにスクロール
                            block: "center", // 中央にスクロール
                        });
                    }

                    const panelId = panel.id;
                    const button = document.querySelector(`button[data-panel="${panelId}"]`);
                    if (button) {
                        const group = button.closest(".group");
                        if (group) group.classList.add("opened");
                    }
                }

                const menuThird = parentItem.closest(".menu_third");
                if (menuThird) {
                    menuThird.classList.add("open");
                }

                const parentLi = parentItem.closest("li");
                if (parentLi) {
                    const label = parentLi.querySelector("label");
                    if (label) label.classList.add("open");
                }

                const navList = document.querySelector(".nav-content");
                if (navList) navList.classList.add("open");

                const toggleCloseButton = document.getElementById("toggle-close");
                const toggleMenuButton = document.getElementById("toggle-menu");
                if (toggleCloseButton && toggleMenuButton) {
                    toggleCloseButton.style.display = "block";
                    toggleMenuButton.style.display = "none";
                }
            }
        });

        // 2. マッチしなかった場合の通常処理
        if (!foundMatch) {
            document.querySelectorAll(".menu-global-panel ul li a").forEach((item) => {
                if (
                    item.hostname === location.hostname && // 外部リンク除外
                    item.pathname === currentPath
                ) {
                    let currentElement = item.closest("li");
                    const parentPanel = item.closest(".menu-global-panel");
                    if (parentPanel) {
                        parentPanel.classList.add("open");
                        
                        setTimeout(() => {
                            const currentItem = parentPanel.querySelector(".current");
                            if (currentItem) {
                                currentItem.scrollIntoView({
                                    behavior: "smooth", // スムーズにスクロール
                                    block: "center", // 中央にスクロール
                                });
                            }
                        }, 300);

                        const panelId = parentPanel.id;
                        const correspondingButton = document.querySelector(`button[data-panel="${panelId}"]`);
                        if (correspondingButton) {
                            const parentGroup = correspondingButton.closest(".group");
                            if (parentGroup) {
                                parentGroup.classList.add("opened");
                            }
                        }
                    }

                    while (currentElement) {
                        const parentLabel = currentElement.querySelector("label");
                        if (parentLabel) parentLabel.classList.add("open");

                        if (currentElement.classList.contains("current") || currentElement.classList.contains("menu-ancestor")) {
                            const parentMenuThird = currentElement.closest(".menu_third");
                            if (parentMenuThird) {
                                parentMenuThird.classList.add("open");
                            }
                        }

                        currentElement = currentElement.closest("li")?.parentElement.closest("li");
                    }
                }
            });
        }
        // const panels = document.querySelectorAll(".menu-global-panel");
    };

    // 第1階層ボタンの情報を関連パネルに反映
    firstLevelButtons.forEach((button) => {
        const parentLi = button.closest("li");
        const parentClass = parentLi ? parentLi.className : "";
        const buttonText = button.textContent;
        const panelId = button.dataset.panel;
        const targetPanel = document.getElementById(panelId);

        if (targetPanel) {
            const selectedClassEl = targetPanel.querySelector(".selected-info .selected-class");
            const selectedTextEl = targetPanel.querySelector(".selected-info .selected-text");

            if (selectedClassEl && selectedTextEl) {
                selectedClassEl.classList.add(...parentClass.split(" "));
                selectedTextEl.textContent = buttonText;
            }
        }
    });

    // ページパディングの更新
    const updatePagePadding = () => {
        const isSpecialPage = document.body.classList.contains("page-template-template-curation") || document.body.classList.contains("home");

        if (isSpecialPage) return;

        let totalWidth = 0;
        const isOpen = navList.classList.contains("open");

        if (window.innerWidth >= 1056 && window.innerWidth < 1280) {
            if (isOpen) {
                totalWidth = 224;
                headerMain.classList.add("small");
            }
            panels.forEach((panel) => {
                if (panel.classList.contains("open")) {
                    totalWidth = panel.offsetWidth;
                }
            });
        } else if (window.innerWidth >= 1280) {
            if (isOpen) {
                totalWidth += navList.offsetWidth;
                headerMain.classList.add("small");
            }
            panels.forEach((panel) => {
                if (panel.classList.contains("open")) {
                    totalWidth += panel.offsetWidth;
                }
            });
        }

        page.style.paddingLeft = `${totalWidth}px`;
    };

    // トグルボタンの表示/非表示更新
    const updateToggleMenuVisibility = () => {
        const isOpen = navList.classList.contains("open");
        toggleMenuButton.style.display = isOpen ? "none" : "block";
    };

    // マウスエンターでメニューを開く処理
    const handleMouseEnter = () => {
        if (disableMouseEnter || window.innerWidth < 1280 || navList.classList.contains("open")) return;

        showMenu();

        const isSpecialPage = document.body.classList.contains("page-template-template-curation") || document.body.classList.contains("home");
        if (!isSpecialPage) {
            headerMain.classList.add("small");
            setActiveMenu();
        }
    };

    const handleEvent = (event) => {
        event.stopPropagation();
        const targetPanelId = event.target.dataset.panel;
        const targetPanel = document.getElementById(targetPanelId);

        if (targetPanel) {
            panels.forEach((panel) => panel.classList.remove("open"));

            const openedGroup = document.querySelector(".group.opened");
            if (openedGroup) {
                openedGroup.classList.remove("opened");
            }

            targetPanel.classList.toggle("open");

            const parentGroup = event.target.closest(".group");
            if (parentGroup) {
                parentGroup.classList.add("opened");
            }

            navList.classList.add("open");
            updatePagePadding();

            // 💡 親の .menu-item にクラスを追加
            //. toggleParentClass(event.target);
        }
    };

    // イベントリスナー設定
    if (document.body.classList.contains("page-template-default")) {
        document.body.classList.add("disable");
        setTimeout(() => document.body.classList.remove("disable"), 100);
    }

    toggleMenuButton.addEventListener("click", showMenu);
    toggleMenuButton.addEventListener("mouseenter", handleMouseEnter);
    toggleCloseButton.addEventListener("click", hideMenu);

    // ファーストレベルボタンのイベントリスナー
    document.querySelectorAll(".nav-list button[data-panel]").forEach((button) => {
        button.addEventListener("click", (event) => {
            event.stopPropagation();
            openPanel(button.dataset.panel);
        });
    });

    // マウスエンターでパネルを開く処理（1280px以上のみ）
    firstLevelButtons.forEach((button) => {
        button.addEventListener("mouseenter", () => {
            if (disableMouseEnter || window.innerWidth < 1280) return;
            openPanel(button.dataset.panel);
        });
    });

    // 戻るボタン処理
    // 戻るボタン処理
    document.body.addEventListener("click", (event) => {
        if (event.target && event.target.matches(".back")) {
            // イベントの伝播を停止
            event.stopPropagation();

            // パネルを閉じる（open クラスを削除するだけ）
            panels.forEach((panel) => panel.classList.remove("open"));

            // ページパディングを更新
            updatePagePadding();
        }
    });

    //        // Gnav 以外の部分をクリックしたらメニューを閉じる
    document.body.addEventListener("click", (event) => {
        const breakpoint = 1056;
        const isSmallScreen = window.innerWidth < breakpoint;
        const isSpecialPage = document.body.classList.contains("page-template-template-curation") || document.body.classList.contains("home");
        //if (!navList.classList.contains("open")) return; // ✅ Gnav が開いているときのみ処理
        //
        const ignoredTags = ["A", "BUTTON", "DETAILS", "SUMMARY", "INPUT", "TEXTAREA", "SELECT", "OPTION", "LABEL", "VIDEO", "AUDIO", "OBJECT", "EMBED", "IFRAME"];
        // 無視する要素のクリック時は処理しない
        if (ignoredTags.includes(event.target.tagName)) return;
        // Gnav、トグルボタン、パネル、navList、階層ラベルも含めてクリックは無視
        const isClickInsideMenu =
            navList.contains(event.target) || // ✅ navList 本体
            toggleMenuButton.contains(event.target) || // ✅ 開閉ボタン
            toggleCloseButton.contains(event.target) || // ✅ 閉じるボタン
            Array.from(navList.querySelectorAll(".menu-global-panel")).some((panel) => panel.contains(event.target)) || // ✅ 下階層パネル
            event.target.closest(".menu_third") || // ✅ 第3階層のクリック
            event.target.closest(".selected-info");
        if (isSpecialPage || isSmallScreen) {
            hideMenu();
        }
    });

    // ナビゲーション内のクリックは伝播を防ぐ
    navList.addEventListener("click", (event) => {
        event.stopPropagation();
    });

    // サブメニューの開閉
    document.querySelectorAll(".menu_second > li > label").forEach((label) => {
        label.addEventListener("click", () => {
            const parentLi = label.closest("li");
            const menu = parentLi.querySelector(".menu_third");
            if (menu) menu.classList.toggle("open");
            label.classList.toggle("open");
        });
    });

    document.querySelectorAll(".nav-list button[data-panel]").forEach((button) => {
        const eventType = window.innerWidth <= 1280 ? "click" : "mouseenter";

        button.addEventListener(eventType, (event) => handleEvent(event));
    });

    // トランジション処理
    setTimeout(() => {
        const menuPanels = document.querySelectorAll(".menu-global-panel .menu_second li>label, menu-global-panel .menu_third");
        menuPanels.forEach((panel) => panel.classList.add("no-transition"));
    }, 0);

    // setTimeout(() => {
    //     const menuPanels = document.querySelectorAll(".menu-global-panel .menu_second li>label, menu-global-panel .menu_third");
    //     menuPanels.forEach((panel) => panel.classList.remove("no-transition"));
    // }, 800);

    // リサイズイベント

    window.addEventListener("resize", () => {
        updatePagePadding();
        updateToggleMenuVisibility();

        const isBelow = window.innerWidth < 1056;
        const isSpecialPage = document.body.classList.contains("page-template-template-curation") || document.body.classList.contains("home");

        if (isBelow || isSpecialPage) {
            hideMenu(); // 小さい画面または特別ページでは非表示に
        } else {
            showMenu(); // 大きい画面では表示に
        }
    });

    // 初期化処理
    setTimeout(() => updateToggleMenuVisibility(), 0);
    initializeMenuState();
    //  console.log(panels);
    //     setTimeout(() => {
    //         //const panels = document.querySelectorAll(".menu-global-panel");
    //         const parentMenu = document.querySelector(".menu-global-panel .menu_second, .menu-global-panel .menu_third");
    //         const currentItem = parentMenu?.querySelector(".current");
    //         console.log(parentMenu);
    //
    //         if (currentItem && parentMenu) {
    //             // current が見えるようにスクロール
    //             currentItem.scrollIntoView({
    //                 block: "nearest",
    //                 behavior: "smooth", // スムーズスクロール
    //             });
    //         }
    //     }, 400);

    // [data-nc-links] と [data-nc-links-ns] のすべてのリンクを選択
    const links = document.querySelectorAll("[data-nc-links] a");
    //console.log(links);
    links.forEach((link) => {
        // リンクのテキストノードを取得
        const textNode = link.firstChild;

        // テキストがある場合のみ処理
        if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            // テキストを<span>で囲む
            const span = document.createElement("span");
            span.textContent = textNode.textContent;

            // 現在のリンク内容を変更
            link.innerHTML = link.innerHTML.replace(textNode.textContent, span.outerHTML);
        }
    });
});

// menu-global-panel の open クラス監視
const observeMenuOpen = () => {
    const panels = document.querySelectorAll(".menu-global-panel");
    const navList = document.querySelector(".nav-content");
  //  const isOpen = navList.classList.contains("open");
    // const handlePanelOpen = (isOpen) => {
    //     // ✅ 1280px 未満の時だけクリック無効化
    //     if (window.innerWidth < 1280) {
    //         if (isOpen) {
    //            // console.log("パネルが開かれました（1280px未満）：navList を無効化します");
    //             navList.style.pointerEvents = "none"; // ✅ クリック無効化
    //         } else {
    //             console.log("パネルが閉じました（1280px未満）：navList を有効化します");
    //             navList.style.pointerEvents = "auto"; // ✅ クリック再開
    //         }
    //     } else {
    //         // ✅ 1280px 以上の場合は常にクリック有効
    //         navList.style.pointerEvents = "auto";
    //     }
    // };

    // MutationObserverの設定
    const observer = new MutationObserver((mutationsList) => {
        let isPanelOpen = false;

        mutationsList.forEach((mutation) => {
            if (mutation.attributeName === "class") {
                // いずれかのパネルに open クラスがあるか確認
                isPanelOpen = Array.from(panels).some((panel) => panel.classList.contains("open"));
            }
        });

        // open 状態の変更時に処理
       // handlePanelOpen(isPanelOpen);
    });

    // すべてのパネルを監視
    panels.forEach((panel) => {
        observer.observe(panel, {
            attributes: true, // 属性の変更を監視
            attributeFilter: ["class"], // class のみ監視
        });
    });

    // ✅ リサイズ時にクリック可能状態を再評価
    window.addEventListener("resize", () => {
        // パネルが開いている場合、リサイズ後の状態を再評価
        const isPanelOpen = Array.from(panels).some(panel => panel.classList.contains("open"));
        //handlePanelOpen(isPanelOpen);
    });
};

// 初期化で監視開始
observeMenuOpen();

/**
 * Dynamic Filter - Lists by Terms
 *
 * @author Space-Time Inc.
 * @version 2024-02-28
 */

(() => {
    class DynamicFilter {
        #maxCount;

        #bs;
        #its;
        #as;

        constructor(flt, list, arch) {
            this.#maxCount = parseInt(list.dataset?.maxCount ?? "6");

            this.#bs = flt.querySelectorAll("button");
            this.#its = list.querySelectorAll(":scope > li");
            this.#as = arch.querySelectorAll("a");

            this.#hideEmpty(list);
            for (const b of this.#bs) b.addEventListener("click", (e) => this.#onClick(e));
            this.#bs[0].click();
        }

        #hideEmpty(list) {
            for (const b of this.#bs) {
                const t = b.dataset.type;
                if ("all" === t) continue;

                const it = list.querySelector(`:scope > li.${t}`);
                if (!it) {
                    b.classList.add("empty");
                    const p = b.parentElement;
                    if ("LI" === p.tagName) p.classList.add("empty");
                }
            }
        }

        #onClick(e) {
            const cur = e.currentTarget;
            for (const b of this.#bs) {
                const p = b.parentElement;
                if (cur === b) {
                    b.classList.add("current");
                    if ("LI" === p.tagName) p.classList.add("current");
                } else {
                    b.classList.remove("current");
                    if ("LI" === p.tagName) p.classList.remove("current");
                }
            }
            const t = cur.dataset.type;
            for (const a of this.#as) {
                a.style.display = t === a.dataset.type ? "" : "none";
            }
            this.#filterItems(t, this.#maxCount);
        }

        #filterItems(t, count) {
            for (const it of this.#its) {
                if (count) {
                    const v = "all" === t || it.classList.contains(t);
                    if (v) {
                        it.style.display = "";
                        count -= 1;
                    } else {
                        it.style.display = "none";
                    }
                } else {
                    it.style.display = "none";
                }
            }
        }
    }

    const fs = document.querySelectorAll(".part-dynamic-filter");
    if (1 === fs.length) {
        let l = document.querySelector(".part-dynamic-filter + .list-item");
        let a = document.querySelector(".part-dynamic-archive");

        if (!l) {
            const id = fs[0].dataset?.filterId ?? "";
            if (id) {
                l = document.querySelector(`.list-item[data-filter-id='${id}']`);
                if (!a) a = document.querySelector(`.part-dynamic-archive[data-filter-id='${id}']`);
            }
        }
        if (l && a) new DynamicFilter(fs[0], l, a);
    } else {
        for (const f of fs) {
            const id = f.dataset?.filterId ?? "";
            if (id) {
                const l = document.querySelector(`.list-item[data-filter-id='${id}']`);
                const a = document.querySelector(`.part-dynamic-archive[data-filter-id='${id}']`);
                if (l && a) new DynamicFilter(f, l, a);
            }
        }
    }
})();

/**
 * Dynamic Filter - Lists by Terms
 *
 * @author Space-Time Inc.
 * @version 2025-05-29
 */

document.addEventListener("DOMContentLoaded", () => {
 
  const hash = window.location.hash;
  if (!hash) return;

  const target = document.querySelector(hash);
  if (!target) return;
   console.log(target);
  // 親に <details> を持つ場合だけ処理する
  let current = target.parentElement;
  let foundDetails = null;

  while (current) {
    if (current.tagName.toLowerCase() === 'details') {
      foundDetails = current;
      break;
    }
    current = current.parentElement;
  }

  if (foundDetails) {
    foundDetails.open = true;

    // スクロール処理（遅延付き）
    setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }
});
document.addEventListener("DOMContentLoaded", function () {
    const seeMoreButtonWraps = document.querySelectorAll('.see-more-button-wrap');

    if (!seeMoreButtonWraps.length) {
        return;
    }

    seeMoreButtonWraps.forEach((wrap) => {
        // ボタンとリストを取得
        const button = wrap.querySelector('.see-more-button');
        const relatedTagList = wrap.previousElementSibling;

        if (!button || !relatedTagList || !relatedTagList.classList.contains('list-item-related-tag')) {
            return;
        }
        // ボタンクリックイベント
        button.addEventListener('click', function () {
            if (relatedTagList.classList.contains('hidden')) {
                relatedTagList.classList.remove('hidden');
                relatedTagList.classList.add('active');
                button.classList.remove('down');
                button.classList.add('up');
                button.innerText = "See less"; // ボタンのテキスト変更
            } else {
                relatedTagList.classList.remove('active');
                relatedTagList.classList.add('hidden');
                button.classList.remove('up');
                button.classList.add('down');
                button.innerText = "See more"; // ボタンのテキスト変更
            }
        });
    });
});
